module.exports = __webpack_public_path__ + "img/accessTip.55612c0f.png";